<button mat-icon-button class="absolute right-4 top-2" (click)="close()">
  <mat-icon>close</mat-icon>
</button>
<div class="flex flex-1 w-screen h-screen py-12 px-14 bg-transparent" *ngIf="direccionGmap$ | async as direccion">
  <agm-map class="h-full w-full" [zoom]='15' [latitude]= 'convertir(direccion.lat)' [longitude]='convertir(direccion.log)'>
    <agm-marker iconUrl='assets/marker.svg' [latitude]="convertir(direccion.lat)" [longitude]='convertir(direccion.log)'>
      <agm-snazzy-info-window [closeWhenOthersOpen]="true" borderRadius='10px' pointer='10px'>
        <ng-template>
          <div class="flex flex-none">
            {{direccion.completa}}
          </div>
        </ng-template>
      </agm-snazzy-info-window>
    </agm-marker>
  </agm-map>
</div>
